import React, { useState } from 'react';
import { Layout } from '../../components';
import { toast } from 'react-toastify';
import { useNavigate, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useAddServiceMutation } from '../../store/services/storeService';
import { useFetchCategoriesQuery } from '../../store/services/categoriesService';
import Loader from '../../components/Loader';

const AddService = () => {
    const { id } = useParams();
    const { data: categories, isLoading, error } = useFetchCategoriesQuery();
    const [addService, { isLoading: isAddingService }] = useAddServiceMutation();
    const words = useSelector((state) => state.authReducer.words);
    const navigate = useNavigate();
    

    const [form, setForm] = useState({
        title: '',
        detail: '',
        price: '',
        service_duration: '',
        category_id: '',
        discount: 0,
        final_price: ''
    });
    const [serviceImages, setServiceImages] = useState([]);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        let updatedForm = { ...form, [name]: value };

        if (name === 'price' || name === 'discount') {
            const price = parseFloat(updatedForm.price) || 0;
            const discount = parseFloat(updatedForm.discount) || 0;
            updatedForm.final_price = (price - (price * discount) / 100).toFixed(2);
        }

        setForm(updatedForm);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const formData = new FormData();

        Object.keys(form).forEach((key) => {
            formData.append(key, form[key]);
        });
        serviceImages.forEach((file) => {
            formData.append('serviceImages[]', file);
        });
        formData.append('store_id', id);

        try {
            const response = await addService(formData).unwrap();
            if (response.status) {
                toast.success('Service added successfully');
                navigate(`/dashboard/store-detail/${id}`);
            } else {
                toast.error('Failed to add service.');
            }
        } catch (error) {
            toast.error(error?.data?.error ?? 'An error occurred while adding the service.');
        }
    };

    return (
        <Layout pageTitle={words["Add Service"]}>
            <Loader open={isLoading || isAddingService} />
            <div className="p-9 pt-0 bg-white rounded-lg">
                <form onSubmit={handleSubmit} className="space-y-4">
                    <div className="grid grid-cols-2 gap-4">
                        <div>
                            <label className="block text-sm font-medium">{words["Title"]}</label>
                            <input
                                type="text"
                                name="title"
                                value={form.title}
                                onChange={handleInputChange}
                                className="w-full mt-1 p-2 border rounded-lg"
                                required
                            />
                        </div>

                        <div>
                            <label className="block text-sm font-medium">{words["Price"]}</label>
                            <input
                                type="number"
                                name="price"
                                value={form.price}
                                onChange={handleInputChange}
                                className="w-full mt-1 p-2 border rounded-lg"
                                required
                            />
                        </div>
                    </div>

                    <div>
                        <label className="block text-sm font-medium">{words["Detail"]}</label>
                        <textarea
                            name="detail"
                            value={form.detail}
                            onChange={handleInputChange}
                            className="w-full mt-1 p-2 border rounded-lg"
                            required
                        ></textarea>
                    </div>

                    <div className="grid grid-cols-2 gap-4">
                        <div>
                            <label className="block text-sm font-medium">{words["Discount"]} (%)</label>
                            <input
                                type="number"
                                name="discount"
                                value={form.discount}
                                onChange={handleInputChange}
                                className="w-full mt-1 p-2 border rounded-lg"
                                required
                            />
                        </div>
                        <div>
                            <label className="block text-sm font-medium">{words["Final price"]}</label>
                            <input
                                value={form.final_price}
                                disabled
                                className="w-full mt-1 p-2 border rounded-lg bg-gray-100"
                            />
                        </div>
                    </div>

                    <div className="grid grid-cols-2 gap-4">
                        <div>
                            <label className="block text-sm font-medium">{words["Service Duration (Minutes)"]} </label>
                            <input
                                type="number"
                                name="service_duration"
                                value={form.service_duration}
                                onChange={handleInputChange}
                                className="w-full mt-1 p-2 border rounded-lg"
                                required
                            />
                        </div>
                        <div>
                            <label className="block text-sm font-medium">{words["Category"]}</label>
                            {isLoading ? (
                                <p>Loading categories...</p>
                            ) : error ? (
                                <p className="text-red-500">Failed to load categories</p>
                            ) : (
                                <select
                                    name="category_id"
                                    value={form.category_id}
                                    onChange={handleInputChange}
                                    className="w-full mt-1 p-2 border rounded-lg"
                                    required
                                >
                                    <option value="" disabled>{words["Select Category"]}</option>
                                    {categories?.data?.map((category) => (
                                        <option key={category.id} value={category.id}>
                                            {category.name}
                                        </option>
                                    ))}
                                </select>
                            )}
                        </div>
                    </div>

                    <div>
                        <label className="block text-sm font-medium">{words["Service Images"]}</label>
                        <input
                            type="file"
                            accept="image/*"
                            name="image"
                            id="upload_img"
                            className="cleanbtn"
                            onChange={(e) => setServiceImages([...serviceImages, e.target.files[0]])}
                        />
                    </div>

                    <button
                        type="submit"
                        className="bg-themeColor min-w-[200px] h-[47px] px-3 text-base text-center text-white font-semibold rounded-full cursor-pointer"
                    >
                        {words["Submit"]}
                    </button>
                </form>
            </div>
        </Layout>
    );
};

export default AddService;


// import React, { useState } from 'react';
// import { Layout } from '../../components';
// import { BASE_URL } from '../../Api/constants';
// import { postRequest, postRequestFormData } from '../../Api';
// import Loader from '../../components/Loader';
// import { useFetchCategoriesQuery } from '../../store/services/categoriesService';
// import { toast } from 'react-toastify';
// import { useNavigate, useParams } from 'react-router-dom';
// import { useSelector } from 'react-redux';
// import { useAddServiceMutation } from '../../store/services/storeService';

// const AddService = () => {

//     const { id } = useParams();
//     const { data: categories, isLoading, error } = useFetchCategoriesQuery();
//     const [addService, { isLoading: isAddingService }] = useAddServiceMutation();

//     const [loading, setLoading] = useState(false);
//     const words = useSelector((state) => state.authReducer.words);
//     const navigate = useNavigate();

//     const [form, setForm] = useState({
//         title: '',
//         detail: '',
//         price: '',
//         service_duration: '',
//         category_id: '',
//         tamsir_types: [],
//         tamsir_colors: [],
//         accessories: [],
//         discount: 0,
//         final_price: ''
//     });
//     const [serviceImages, setServiceImages] = useState([]);

//     const handleInputChange = (e) => {
//         const { name, value } = e.target;
//         setForm({ ...form, [name]: value });
//     };

//     const handleSubmit = async (e) => {
//         e.preventDefault();
//         const formData = new FormData();

//         Object.keys(form).forEach((key) => {
//             if (Array.isArray(form[key])) {
//                 form[key].forEach((item, index) => {
//                     formData.append(`${key}[${index}]`, item);
//                 });
//             } else {
//                 formData.append(key, form[key]);
//             }
//         });
//         for (let key of serviceImages) {
//             formData.append('serviceImages[]', key);
//         }
//         formData.append('store_id', id);

//         try {
//             const response = await addService(formData).unwrap();
//             console.log('response', response);
//             if (response.status) {
//                 toast.success('Service added successfully');
//                 navigate('/dashboard/store-detail/' + id);
//                 // Optionally reset the form
//             } else {
//                 toast.error("Failed to add vehicle.");
//             }
//         } catch (error) {
//             // console.log('asd', error)
//             toast.error(error?.data?.error ?? "An error occurred while adding the vehicle.");
//             console.error(error);
//         }

//     };

//     return (
//         <Layout pageTitle={words["Add Service"]} >
//             <Loader open={isLoading || isAddingService} />
//             <div className="p-9 pt-0 bg-white rounded-lg ">
//                 <form onSubmit={handleSubmit} className="space-y-4">
//                     <div>
//                         <label className="block text-sm font-medium">Title</label>
//                         <input
//                             type="text"
//                             name="title"
//                             value={form.title}
//                             onChange={handleInputChange}
//                             className="w-full mt-1 p-2 border rounded-lg"
//                             required
//                         />
//                     </div>

//                     <div>
//                         <label className="block text-sm font-medium">Detail</label>
//                         <textarea
//                             name="detail"
//                             value={form.detail}
//                             onChange={handleInputChange}
//                             className="w-full mt-1 p-2 border rounded-lg"
//                             required
//                         ></textarea>
//                     </div>

//                     <div>
//                         <label className="block text-sm font-medium">Price</label>
//                         <input
//                             type="number"
//                             name="price"
//                             value={form.price}
//                             onChange={handleInputChange}
//                             className="w-full mt-1 p-2 border rounded-lg"
//                             required
//                         />
//                     </div>

//                     <div>
//                         <label className="block text-sm font-medium">Discount</label>
//                         <input
//                             type="number"
//                             name="discount"
//                             value={form.discount}
//                             onChange={handleInputChange}
//                             className="w-full mt-1 p-2 border rounded-lg"
//                             required
//                         />
//                     </div>

//                     <div>
//                         <label className="block text-sm font-medium">Final price</label>
//                         <input
//                             value={form.final_price}
//                             disabled
//                             className="w-full mt-1 p-2 border rounded-lg"
//                         />
//                     </div>

//                     <div>
//                         <label className="block text-sm font-medium">Service Duration (Minutes)</label>
//                         <input
//                             type="number"
//                             name="service_duration"
//                             value={form.service_duration}
//                             onChange={handleInputChange}
//                             className="w-full mt-1 p-2 border rounded-lg"
//                             required
//                         />
//                     </div>

//                     <div>
//                         <label className="block text-sm font-medium">Category</label>
//                         {isLoading ? (
//                             <p>Loading categories...</p>
//                         ) : error ? (
//                             <p className="text-red-500">Failed to load categories</p>
//                         ) : (
//                             <select
//                                 name="category_id"
//                                 value={form.category_id}
//                                 onChange={(e) => setForm({ ...form, category_id: e.target.value })}
//                                 className="w-full mt-1 p-2 border rounded-lg"
//                                 required
//                             >
//                                 <option value="" disabled>
//                                     Select a Category
//                                 </option>
//                                 {categories?.data?.map((category) => (
//                                     <option key={category.id} value={category.id}>
//                                         {category.name}
//                                     </option>
//                                 ))}
//                             </select>
//                         )}
//                     </div>


//                     <div>
//                         <label className="block text-sm font-medium">Service Images</label>
//                         <input
//                             type="file"
//                             accept="image/*"
//                             title=""
//                             name="image"
//                             id="upload_img"
//                             className=" cleanbtn"
//                             onChange={(e) => {
//                                 let arr = [...serviceImages];
//                                 arr.push(e.target.files[0]);
//                                 setServiceImages(arr);
//                                 // setImg(e.target.files[0]);
//                             }}
//                         />


//                     </div>

//                     <button
//                         type="submit"
//                         className="bg-themeColor min-w-[200px] h-[47px] px-3 text-base text-center text-white font-semibold rounded-full cursor-pointer"
//                     >
//                         Submit
//                     </button>
//                 </form>
//             </div>
//         </Layout>
//     );
// };

// export default AddService;
